/**
 * @param url defines url will be opened by browser in a new guide.
 */
export function openNewTab(url) {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
}
